
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

export default class DroppableBoxController {
	constructor($log, $state, $timeout) {
		'ngInject';
		this.$log = $log;
		this.$state = $state;
		this.$timeout = $timeout;
	}    

	$onInit(){
		if(_.isUndefined(this.data.text))
			this.wordExp = "any";
		else
			this.wordExp = this.data.text;
		this.class = "empty "+this.data.class;		
	}

	onDropWord(dataDrop){
		let $ctrl = this;
		if(_.isUndefined(this.wordDropped)){
			if((dataDrop.word.text === this.wordExp) || (this.wordExp === "any")){
				this.wordDropped = dataDrop.word.text;
				this.class = this.data.class+" zoomIn";
				this.$timeout(() => $ctrl.class = $ctrl.data.class+" success",600);
				this.endGame(dataDrop);
			}
			else{
				this.class = "empty "+this.data.class;
				this.$timeout(() => $ctrl.class = "empty "+$ctrl.data.class+" fail",100);
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/ui/droppable-box/droppable-box.controller.js